export default {"src":"/_next/static/media/comment.8e641f38.svg","height":16,"width":16};